module.exports = __webpack_public_path__ + "img/table-settings.160303fa.svg";